import {
  faDollar,
  faEuroSign,
  faSterlingSign,
} from '@fortawesome/pro-solid-svg-icons';

import type { SupportedCurrency } from '#src/__generated__/globalTypes.ts';
import { FiatCurrency } from '#src/__generated__/globalTypes.ts';
import type { IconDefinition } from '#src/atoms/icons/index.tsx';

export const fiatCurrencySymbols: Record<FiatCurrency, string> = {
  [FiatCurrency.EUR]: '€',
  [FiatCurrency.GBP]: '£',
  [FiatCurrency.USD]: '$',
};

export const faFiatCurrencySymbols: Record<FiatCurrency, IconDefinition> = {
  [FiatCurrency.EUR]: faEuroSign,
  [FiatCurrency.GBP]: faSterlingSign,
  [FiatCurrency.USD]: faDollar,
};

export const isFiatCurrency = (
  value: SupportedCurrency
): value is FiatCurrency => {
  return Object.values(FiatCurrency).includesValue(value);
};
